import van from "vanjs-core";

const {div, span} = van.tags;


// Ukazatel data a času ve footeru/headeru
export const DateAndTimeFooter = () => {
    const date = van.state('--. --. ----');
    const time = van.state('--:--');

    const fetchTime = () => {
        const dateSetter = new Date();
        date.val = `${dateSetter.getDate()}. ${dateSetter.getMonth() + 1}. ${dateSetter.getFullYear()}`;
        time.val = `${("0" + dateSetter.getHours()).slice(-2)}:${("0" + dateSetter.getMinutes()).slice(-2)}`;
        setTimeout(() => fetchTime(), 60000);
    }
    fetchTime();

    return div({class: "d-flex flex-column align-items-center"},
        span({class: " pl-tag text-white sm-tag-text sm-tag-padding", style: "font-weight: 500 !important;"}, () => date.val),
        span({class: "bg-white pl-tag text-dark-blue sm-tag-padding sm-tag-border sm-tag-text"}, () => time.val),
    );
};

